import { Injectable } from '@angular/core';
import { CxmlPunchOutData, OciPunchOutData, PunchOutData } from '../../model';
import { Occ } from '../../occ';
import { Converter } from '../../util';

@Injectable({ providedIn: 'root' })
export class PunchOutDataNormalizer implements Converter<Occ.PunchOutData, PunchOutData> {
  convert(source: Occ.PunchOutData, target?: PunchOutData): PunchOutData {
    if (source) {
      const properties = {};
      source.properties.entry.forEach((e) => (properties[e.key] = e.value));
      switch (properties['type']) {
        case 'oci':
          return {
            ...properties,
          } as OciPunchOutData;
        case 'cxml':
          return {
            ...properties,
          } as CxmlPunchOutData;
        default:
          throw Error('Unsupported PunchOut');
      }
    }
    return target;
  }
}
